import {Accordion, AccordionDetails, AccordionSummary, Stack, Typography} from "@mui/material";
import {ReactElement} from "react";
import {Edit} from "@carbon/icons-react";

interface AccordionProps {
    header: string,
    children: ReactElement,
    completed: boolean,
    headerIcon?: ReactElement,
    isOpen?: boolean,
    openOnDefault?: boolean,
    headerClick?: () => void
}

export const AccordionWrapper = (props : AccordionProps)  => {

    return (
        <Accordion defaultExpanded={props.openOnDefault} expanded={props.isOpen} >
            <AccordionSummary onClick={props.headerClick}>
                <Stack
                    flex={1}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                >
                    <Typography variant={"subtitle1"} fontWeight={"bold"} >{props.headerIcon ?? <></>}&nbsp;{props.header}</Typography>
                    {props.completed ? <Edit/> : <></>}
                </Stack>
            </AccordionSummary>
            <AccordionDetails>
                {props.children}
            </AccordionDetails>
        </Accordion>
    );
}